import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, LifeBuoy } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Seo } from '@/components/Seo';
import { FaqAccordion } from '@/components/sections/FaqAccordion';
import { CtaBanner } from '@/components/sections/CtaBanner';

export default function Faq() {
  const { t } = useTranslation();
  const faqs = t('faqs', { returnObjects: true });

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };

  return (
    <>
      <Seo title={t('faqPage.seoTitle')} description={t('faqPage.seoDescription')} jsonLd={jsonLd} />

      <section className="relative overflow-hidden px-6 pb-24 pt-32 lg:px-8 sm:pt-40">
        <div className="pointer-events-none absolute right-0 top-24 -z-10 h-96 w-96 rounded-full bg-brand/10 blur-[130px]" />
        <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="text-center lg:sticky lg:top-28 lg:text-left">
              <span className="eyebrow">{t('faqPage.eyebrow')}</span>
              <h1 className="mt-4 font-display text-4xl font-bold leading-[1.1] tracking-tight text-white sm:text-5xl">
                {t('faqPage.title')}
              </h1>
              <p className="mx-auto mt-5 max-w-md text-base leading-relaxed text-white/60 lg:mx-0">
                {t('faqPage.subtitle')}
              </p>
              <div className="mt-8 rounded-2xl border border-brand/20 bg-[#001826]/70 p-6">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand/10 text-brand">
                  <LifeBuoy className="h-5 w-5" />
                </span>
                <p className="mt-4 font-display text-lg font-semibold text-white">{t('faqPage.stillTitle')}</p>
                <p className="mt-1 text-sm text-white/55">{t('faqPage.stillSubtitle')}</p>
                <Link to="/contact" data-testid="faq-contact-cta" className="btn-primary mt-5 text-sm">
                  {t('faqPage.contactCta')} <ArrowRight className="h-4 w-4" />
                </Link>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <FaqAccordion />
          </div>
        </div>
      </section>

      <CtaBanner />
    </>
  );
}
